// Ordbok Bokmål → Nynorsk. Nøkkel = eksakt bokmålstekst brukt i UI. Delt opp per område.
import { NN_COMMON } from "./nn.common";
import { NN_PUBLIC } from "./nn.public";
import { NN_DASHBOARD } from "./nn.dashboard";
import { NN_SHOP } from "./nn.shop";
import { NN_BASAR } from "./nn.basar";

export const NN = { ...NN_COMMON, ...NN_PUBLIC, ...NN_DASHBOARD, ...NN_SHOP, ...NN_BASAR };
